import WithSidebar from 'Layout/WithSidebar';
import image from 'images/small-images-inside-text/plants.jpg';
import { LabelButton } from 'components/buttons/LabelButton/LabelButton';
import GradientText from 'components/GradientText';
import ProductItems from 'components/ProductItems';
import { vegetablesFull } from 'components/ProductItems/mockData';
import Filter from 'components/Filter';
import Banner from 'components/Banner';
import banerImage from 'images/crop-nutrition-programs.jpg';
import { cropNutritionPrograms } from 'components/Filter/mockData';
import { CTAFormSection } from 'components/formSections/CTAFormSection';

const CropNutritionPrograms = () => {
    return (
        <div className="container">
            <Banner title="Crop nutrition programs" image={banerImage} buttonText="Choose a crop" />
            <div className="inner-container">
                <div className="main-text-container">
                    <LabelButton>agricultural solutions</LabelButton>
                    <GradientText>
                        Learn how to care for your plants, providing them with
                        <img src={image} alt="decor" />
                        <em>proper nutrition for maximum crop yield</em>
                    </GradientText>
                </div>

                <WithSidebar Sidebar={<Filter data={cropNutritionPrograms} />}>
                    <div className="box">
                        <ProductItems data={vegetablesFull} />
                    </div>
                </WithSidebar>
            </div>
            <CTAFormSection />
        </div>
    );
};

export default CropNutritionPrograms;
